<app-score-dashboard
    [title]="'MHE Condition Status'"
    [trendingTitle]="'MHE Status Trending'"
    [centerText]="'My Score'"
    [employeeId]="employeeId"
    [daysLookBack]="daysLookBack"
    [palette]="palette"
    [showScore]="true"
    [showTrending]="true"
    [loadScoreData]="loadScoreData"
    [loadTrendingData]="loadTrendingData"
    [exportData]="exportData">
</app-score-dashboard>

